import { DataSource, Label, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutOrderConfirmationStops extends Layout {
	lablePickupsDeliveries: Label;
	sourceOrderStop: DataSource;
	tableStops: Table;
}
